import React, { useEffect, useState } from 'react';
import { spacing } from '../../constants/styles.constants';
import { Column, Container, Row } from '../../components/Layout';
import YoutubeStoriesList from "../../components/YoutubeStoriesList";
import Loading from "../../components/Loading";
import LogoHeading from "../../components/LogoHeading";
import { genericRequest } from "../../utils/request";

// eslint-disable-next-line
export default () => {
    const [storyList, setStoryList] = useState([]);
    const [userData, setUserData] = useState({});
    const [storyListFilterData, setStoryListFilterData] = useState([]);
    const [requestStatus, setRequestStatus] = useState({
        isError: false,
        isLoading: false,
        isSuccess: false
    });
    const [requestUserDataStatus, setRequestUserDataStatus] = useState({
        isError: false, isLoading: false, isSuccess: false,
    });

    useEffect(() => {
        async function getUserData() {
            setRequestUserDataStatus({ isLoading: true });
            const request = await genericRequest({
                endpoint: 'getUserDetails',
                method: 'GET',
            });

            if (request.response) {
                setUserData(request.response.data);
                return setRequestUserDataStatus({ isSuccess: true });
            }

            return setRequestUserDataStatus({ isError: request.error });
        }

        async function getPageData() {
            setRequestStatus({ isLoading: true });
            const request = await genericRequest({ endpoint: 'getYoutubeVideoList' });

            if (request.response) {
                setStoryList(request.response.data);
                setStoryListFilterData(request.response.data);
                return setRequestStatus({ isSuccess: true });
            }

            return setRequestStatus({ isError: request.error });
        }

        getPageData().then()
        getUserData().then()
    }, []);

    const storyListFilter = (event) => {
        const searchTerm = event.target.value
        setStoryListFilterData(storyList.filter(el => el.videoTitle.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1));
    }

    return (
        <Container>
            <LogoHeading />
            <Loading isLoading={requestStatus.isLoading || requestUserDataStatus.isLoading}
                isError={requestStatus.isError || requestUserDataStatus.isError}
                isSuccess={requestStatus.isSuccess && requestUserDataStatus.isSuccess}
                errorMessage={"We Couldn't List Youtube Stories At This Time"}
                successMessage={"We got the Youtube Stories List"}
            >
                <Row space={spacing.large}>
                    <Column space={spacing.large}>
                        <YoutubeStoriesList
                            storyList={storyListFilterData}
                            storyListFilter={storyListFilter}
                            userData={userData}
                        />
                    </Column>
                </Row>
            </Loading>
        </Container>
    );
};
